import React, { useState } from 'react';
import Select from '../../../../common/js/react-select'; //TODO: deprecated, replace once react-select removed
import styles from './Select.module.css';
import '../../../../../components/common/css/react-select.css'; //TODO: deprecated, delete once react-select removed
import selectArrow from '../../../../common/Images/select_arrow.png';

const SettingsSelect = ({
    id,
    value,
    options,
    changed,
    color,
    error,
    clearable = false,
    searchable = false,
    multichoice = false,
    creatable = false,
    header = false,
    wide = false,
    placeholder = null,
    disabled = false
}) => {
    const [focused, setFocused] = useState(false);
    const onValChange = (newVal) => {
        if (multichoice) {
            if (!newVal) {
                return changed(id, []);
            }
            return changed(id, Array.isArray(newVal) ? newVal : newVal.split(','));
        }
        changed(id, newVal);
    };

    const selectStyles = [styles.selectInput];
    const containerStyle = [styles.selectContainer];
    if (header) {
        containerStyle.push(styles.header);
        selectStyles.push(styles.selectInputHeader);
    }
    if (wide) {
        containerStyle.push(styles.wide);
        selectStyles.push(styles.wide);
    }
    if (multichoice) {
        selectStyles.push(styles.multi);
    } else {
        selectStyles.push(styles.single);
    }
    if (creatable) {
        selectStyles.push(styles.creatable);
    }
    if (color === 'grey') {
        selectStyles.push(styles.grey);
    }
    if (error) {
        selectStyles.push(styles.error);
    }

    if (
        Array.isArray(value) &&
        value.length === Object.keys(options).length &&
        (value.length !== 1 || value[0] !== '')
    ) {
        selectStyles.push(styles.hiddenArrow);
    }

    const getFilteredGroups = (input) => {
        return Promise.resolve({
            options: options.filter((option) => option.label.toLowerCase().includes(input.toLowerCase()))
        });
    };

    return (
        <div className={containerStyle.join(' ')}>
            {!creatable && (
                <Select
                    placeholder={placeholder}
                    className={selectStyles.join(' ')}
                    value={value}
                    onChange={onValChange}
                    clearable={clearable}
                    searchable={searchable}
                    backspaceRemoves={false}
                    simpleValue
                    multi={multichoice}
                    options={options}
                    arrowRenderer={() => <img src={selectArrow} alt="" />}
                    valueRenderer={(option) => <span title={option.label}>{option.label}</span>}
                    disabled={disabled}
                />
            )}
            {creatable && (
                <Select.AsyncCreatable
                    placeholder={placeholder || 'Select or create'}
                    className={selectStyles.join(' ')}
                    name="form-field-name"
                    value={
                        multichoice
                            ? value.map((val) => {
                                  return { value: val, label: val };
                              })
                            : { value: value, label: value }
                    }
                    onChange={onValChange}
                    clearable={clearable}
                    searchable={true}
                    backspaceRemoves={multichoice}
                    loadOptions={getFilteredGroups}
                    options={options}
                    valueKey="value"
                    labelKey="label"
                    multi={multichoice}
                    onFocus={() => {
                        setFocused(true);
                    }}
                    onBlur={() => {
                        setFocused(false);
                    }}
                    autoBlur={true}
                    arrowRenderer={() => {
                        if (multichoice && !options.length) {
                            return null;
                        }
                        return <img src={selectArrow} alt="" />;
                    }}
                    valueRenderer={(option) => (
                        <span title={option.label}>{focused && !multichoice ? '' : option.label}</span>
                    )}
                />
            )}
            {error && <div className={styles.errorText}>{error}</div>}
        </div>
    );
};

export default React.memo(SettingsSelect);
